<template>
  <div class="actual">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow">场地实况</div>
      <div class="nav-right"></div>
    </div>
    <div style="margin-top: 44px">
      <div class="venues-each" v-for="(item, index) in venuesData" :key="index">
        <div class="fs-md d-flex type-top">
          <div class="font-0">{{ item.venueName }}/{{ item.itemName }}</div>
          <!-- <div class="order-btn" @click="pageToOrder(item)">预约</div> -->
        </div>
        <div class="d-flex type-num">
          <div class="font-0 weight">{{ item.areaSum - item.areaNum }}</div>
          <div class="type-imgs d-flex">
            <div v-for="(currnum, index) in zrr" :key="currnum">
              <img v-if="ifShow(item, index)" :src="nums[item.itemName].img" />
              <img v-else :src="nums[item.itemName].img2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVenueFacts } from '@/api/api-venueOrder'
export default {
  components: {},
  data() {
    return {
      title: '场地实况',
      // rightImg: require("@/static/img/refresh.svg"),
      rightImg: '',
      routeQuery: '',
      venuesData: [
        // { venueName: '场馆1', itemName: '羽毛球', areaSum: 5, areaNum: 3 },
        // { venueName: '场馆2', itemName: '足球', areaSum: 8, areaNum: 4 },
        // { venueName: '场馆3', itemName: '篮球', areaSum: 0, areaNum: 0 },
      ],
      zrr: [1, 2, 3, 4, 5],
      isLoading: true,
      nums: {
        羽毛球: {
          id: 0,
          name: '羽毛球馆',
          img: require('@/assets/img/ball/badminton.png'),
          img2: require('@/assets/img/ball/badminton2.png'),
        },
        篮球: {
          id: 1,
          name: '篮球场（北校区）',
          img: require('@/assets/img/ball/basketball.png'),
          img2: require('@/assets/img/ball/basketball2.png'),
        },
        足球: {
          id: 2,
          name: '足球场（南校区）',
          img: require('@/assets/img/ball/football.png'),
          img2: require('@/assets/img/ball/football2.png'),
        },
        网球: {
          id: 3,
          name: '网球场',
          img: require('@/assets/img/ball/tennis.png'),
          img2: require('@/assets/img/ball/tennis2.png'),
        },
        排球: {
          id: 4,
          name: '排球场',
          img: require('@/assets/img/ball/volleyball.png'),
          img2: require('@/assets/img/ball/volleyball2.png'),
        },
        泳池: {
          id: 5,
          name: '泳池',
          img: require('@/assets/img/ball/pool.png'),
          img2: require('@/assets/img/ball/pool2.png'),
        },
        乒乓球: {
          id: 6,
          name: '乒乓球场',
          img: require('@/assets/img/ball/pingpong.png'),
          img2: require('@/assets/img/ball/pingpong2.png'),
        },
        健身器材: {
          id: 7,
          name: '健身器材',
          img: require('@/assets/img/ball/boxing.png'),
          img2: require('@/assets/img/ball/boxing2.png'),
        },
        健身: {
          id: 8,
          name: '健身器材',
          img: require('@/assets/img/ball/boxing.png'),
          img2: require('@/assets/img/ball/boxing2.png'),
        },
      },
    }
  },
  created() {
    this.getData()
  },
  computed: {
    ifShow() {
      return function (item, currnum) {
        console.log('item:', item)
        console.log('currnum:', currnum)
        if (item.areaSum == 0) return false
        return Math.round((item.areaSum / 5) * (currnum + 1)) <= item.areaSum - item.areaNum
      }
    },
  },
  methods: {
    pageToBack() {
      this.$router.go(-1)
    },
    rightAction() {
      console.log('刷新')
    },
    getData() {
      getVenueFacts().then((res) => {
        if (res.data.statusCode == 1) {
          this.venuesData = res.data.obj
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.actual {
  height: calc(100vh - 44px);
  background: #fff;
}
.venues-each {
  width: calc(100% - 32px);
  padding: 12px 16px;
  height: 109px;
  background: #ffffff;
  box-shadow: 0px 1px 0px #cce4db;
  margin-top: 8px;
  margin-bottom: 8px;
}

.order-btn {
  color: #007a4d;
}

.type-top {
  justify-content: space-between;
}

.type-num {
  width: 100%;
  font-size: 48px;
  margin-top: 20px;
  align-items: center;
  justify-content: space-between;
}

.type-imgs {
  width: calc(100% - 120px);

  img {
    width: 40px;
    height: 40px;
  }

  justify-content: flex-end;
}
</style>
